import { BreadcrumbComponent, Button, CIPageHeader, Loader, useToastMessage } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { DropzoneRootProps, useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router-dom';
import UploadFiles from '../../../../../common/components/layouts/ImportConfiguration/UploadFiles';
import { URL_PATH } from '../../../../constants';
import { AppDispatch, useSelector } from '../../../../store/AppStore';
import { fetchImportServiceSummaryRequest } from '../../../../store/actions/sagaActions/services/ImportServiceSummarySagaAction';
import ImportFiles from '../import-files/ImportFiles';
import classes from './ImportServices.module.scss';

interface FileType {
  length: number,
  lastModified: number,
  name: string,
  webkitRelativePath: string,
  size: number,
  type: string,
}
const ImportServices = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const initialFile: FileType = {
    length: 0,
    lastModified: 0,
    name: '',
    webkitRelativePath: '',
    size: 0,
    type: '',
  };

  const { success: successToast, failure, renderToast, warning } = useToastMessage();
  const [uploadedFilesForJSON, setUploadedFilesForJSON] = useState(initialFile);
  const { success, isLoading, errorMessage } = useSelector(
    (state) => state.ImportServiceSummaryReducer
  );

  const { getRootProps: getRootJSONProps, getInputProps: getInputJSONProps, fileRejections } = useDropzone({
    accept: {
      'application/zip': ['.zip']
    },
    onDrop: (acceptedFile: DropzoneRootProps) => {
      setUploadedFilesForJSON(
        Object.assign(acceptedFile[0], {
          preview: URL.createObjectURL(acceptedFile[0])
        })
      );
    },
    noClick: uploadedFilesForJSON.length !== 0 && !(uploadedFilesForJSON.name?.replace(/.zip/g, '').includes('.'))
  });

  useEffect(() => {
    if (fileRejections.length) {
      warning(
        translate('import_summary_wrapper.error_file_upload_header'),
        translate('import_summary_wrapper.error_file_upload_body'),
        50000
      );
    }
  }, [fileRejections]);

  useEffect(() => {
    if (success) {
      successToast(
        translate('toast_component.lbl_success'),
        translate('import_event_configutation.lbl_toast_success_body')
      );
      setUploadedFilesForJSON(initialFile);
      navigate('/control-plane/services/files/import');
    }
    if (errorMessage) {
      failure(
        translate('toast_component.lbl_error'),
        errorMessage
      );
    }
  }, [errorMessage, success]);

  const handleNavigateToImport = async () => {
    const formData = new FormData();
    const UploadFiles: any = uploadedFilesForJSON;
    formData.append('zip-file', UploadFiles);
    dispatch(fetchImportServiceSummaryRequest(formData));
  };

  const closeHandler = () => {
    navigate(URL_PATH.SERVICE_HOME);
  };
  return (
    <div className={classes['import-service-configuration-main-container']}>
      <Loader show={isLoading} />
      <BreadcrumbComponent />
      {renderToast()}
      <div className={classes['import-service-button']}>
        <CIPageHeader header={translate('import_summary_wrapper.lbl_import_service_configuration')} />
        {success && <Button onClick={closeHandler} variant="secondary" data-testid="btn-close">{translate('multi_form_modal_component.btn_close')}</Button>}
      </div>
      <p className={classes['import-service-configuration-sub-heading']}>{translate('import_summary_wrapper.service_config_subtitle')}</p>

      <Routes>
        <Route
          path="/upload-files"
          element={
            <UploadFiles
              uploadedFilesForJSON={uploadedFilesForJSON}
              getRootJSONProps={getRootJSONProps}
              getInputJSONProps={getInputJSONProps}
              setUploadedFilesForJSON={setUploadedFilesForJSON}
              path={URL_PATH.SERVICE_HOME}
              handleNavigateToImport={handleNavigateToImport}
            />
          }
        />
        <Route path="/import" element={<ImportFiles />} />
      </Routes>
    </div>

  );
};

export default ImportServices;
